import axios from 'axios';

// Together.ai API service
const TOGETHER_AI_API_URL = 'https://api.together.xyz/v1/chat/completions';

// Get API key from environment variable
const API_KEY = process.env.REACT_APP_TOGETHER_AI_API_KEY;

// Set the API key
export const setApiKey = (key) => {
  // Removed the code here as it's not needed with environment variable
};

// Check if API key is set
export const hasApiKey = () => {
  return API_KEY !== '';
};

// Send a message to Together.ai API
export const sendMessage = async (messages, model = 'meta-llama/Llama-3.3-70B-Instruct-Turbo-Free') => {
  if (!API_KEY) {
    throw new Error('Together.ai API key is not set in environment variables');
  }

  try {
    const response = await axios.post(
      TOGETHER_AI_API_URL,
      {
        model: model,
        messages: messages,
        max_tokens: 1024,
        temperature: 0.7,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${API_KEY}`
        }
      }
    );

    return response.data.choices[0].message;
  } catch (error) {
    console.error('Error calling Together.ai API:', error);
    throw error;
  }
};
